/**
 * UI Slice for Wadakaroo
 * Manages UI state: modals, toasts, sidebar, etc.
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    modals: {
        accountSettings: false,
    },
    toast: null,
    sidebarOpen: true,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        openModal: (state, action) => {
            const modalName = action.payload;
            if (state.modals.hasOwnProperty(modalName)) {
                state.modals[modalName] = true;
            }
        },
        closeModal: (state, action) => {
            const modalName = action.payload;
            if (state.modals.hasOwnProperty(modalName)) {
                state.modals[modalName] = false;
            }
        },
        toggleSidebar: (state) => {
            state.sidebarOpen = !state.sidebarOpen;
        },
        showToast: (state, action) => {
            state.toast = {
                message: action.payload.message,
                type: action.payload.type || 'info', // 'success', 'error', 'warning', 'info'
                duration: action.payload.duration || 3000,
            };
        },
        clearToast: (state) => {
            state.toast = null;
        },
    },
});

export const {
    openModal,
    closeModal,
    toggleSidebar,
    showToast,
    clearToast,
} = uiSlice.actions;

// Selectors
export const selectAccountSettingsModalOpen = (state) => state.ui.modals.accountSettings;
export const selectSidebarOpen = (state) => state.ui.sidebarOpen;
export const selectToast = (state) => state.ui.toast;

export default uiSlice.reducer;
